import React, { useState } from 'react';
import { Table, Form, Pagination, Badge } from 'react-bootstrap';

const ProjectList = ({
    projects,
    onEditProject,
    onDeleteProject,
    onSearch,
    onSort,
    sortConfig,
    currentPage,
    projectsPerPage,
    totalProjects,
    paginate
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        onSearch(e.target.value);
    };

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(totalProjects / projectsPerPage); i++) {
        pageNumbers.push(i);
    }

    const getSortDirection = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '↑' : '↓';
        }
        return '';
    };

    const renderStatus = (o) => {
        if ('is_active' in o) {
            return o.is_active ?
                <Badge bg="success">Active</Badge> :
                <Badge bg="warning">Inactive</Badge>;
        }
        return <Badge bg="secondary">Unknown</Badge>;
    };

    return (
        <>
            <div className="card-header d-flex justify-content-between align-items-center">
               <div></div>
                <div>
                    <Form.Control
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>

            </div>

            <div className="mb-2">
                (To Sort by the Information Column, Please Click on the Column Header)
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th style={{ width: '150px' }} onClick={() => onSort('user_id')}>User Name{getSortDirection('lastname')}</th>
                        {/*  <th style={{ width: '150px' }} onClick={() => onSort('user_id')}>Username{getSortDirection('user_id')}</th> */}
                        <th style={{ width: '150px' }} onClick={() => onSort('email')}>Email{getSortDirection('email')}</th>
                        <th style={{ width: '200px' }} onClick={() => onSort('name')}>
                            Project Name {getSortDirection('name')}
                        </th>

                        <th style={{ width: '100px' }} onClick={() => onSort('created_at')}>
                            Created
                            {getSortDirection('created_at')}
                        </th>
                        <th style={{ width: '100px' }} onClick={() => onSort('updated_at')}>
                            Updated
                            {getSortDirection('updated_at')}
                        </th>

                        <th style={{ width: '80px' }} >Files</th>
                        <th style={{ width: '250px' }}>File Names</th>
                        {/* <th style={{ width: '100px' }} onClick={() => onSort('is_active')}>
                            Status {getSortDirection('is_active')}
                        </th> */}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {projects.map(o => (
                        <tr key={o.id}>
                            <td>{o.lastname}, {o.firstname}</td>
                            {/*  <td>{o.user_id}</td> */}
                            <td>{o.email}</td>
                            <td>{o.name}</td>
                            <td>{new Date(o.created_at).toLocaleDateString()}</td>
                            <td>{new Date(o.updated_at).toLocaleDateString()}</td>
                            <td>{o.files?.length || 0}</td>
                            <td>{o.files?.map(file => file.name).join(', ')}</td>
                            {/* <td>{renderStatus(o)}</td> */}
                            <td>

                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => onEditProject(o)}
                                    >
                                        <i className="bi bi-pencil"></i>
                                    </button>
                                    <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => onDeleteProject(o)}
                                    >
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Pagination>
                {pageNumbers.map(number => (
                    <Pagination.Item key={number} active={number === currentPage} onClick={() => paginate(number)}>
                        {number}
                    </Pagination.Item>
                ))}
            </Pagination>
        </>
    );
};

export default ProjectList;